import { render, staticRenderFns } from "./Form8822.vue?vue&type=template&id=0ea261a7&scoped=true&"
import script from "./Form8822.vue?vue&type=script&lang=ts&"
export * from "./Form8822.vue?vue&type=script&lang=ts&"
import style0 from "./Form8822.vue?vue&type=style&index=0&id=0ea261a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea261a7",
  null
  
)

export default component.exports